import axios from 'axios';
import { generateSerieNumber, generateTimestamp, encryptTimestamp, parseXML } from '../utils/utils';

export class FfttService {
  constructor() {
    this.ffttId = process.env.REACT_APP_FFTT_ID;
    this.ffttPass = process.env.REACT_APP_FFTT_PASSWORD;
    this.ffttNumClub = process.env.REACT_APP_FFTT_NUMCLUB;
    this.ffttIdEpr = process.env.REACT_APP_FFTT_IDEPR;
  }

  async fetchEquipes(twoLast) {
    const password = this.ffttPass;
    const idEpr = this.ffttIdEpr
    const serie = generateSerieNumber();
    const tm = generateTimestamp();
    const tmc = encryptTimestamp(tm, password);
  
    try {
      const response = await axios.get('https://www.fftt.com/mobile/pxml/xml_equipe.php', {
        params: {
          serie: serie,
          tm: tm,
          tmc: tmc,
          id: this.ffttId,
          numclu: this.ffttNumClub,
          type: 'M'
        }
      });
  
      const xmlDoc = parseXML(response.data);
      const equipes = Array.from(xmlDoc.getElementsByTagName("equipe")).map(equipe => ({
        idequipe: equipe.getElementsByTagName("idequipe")[0].textContent,
        libequipe: equipe.getElementsByTagName("libequipe")[0].textContent,
        liendivision: equipe.getElementsByTagName("liendivision")[0].textContent,
        idepr: equipe.getElementsByTagName("idepr")[0].textContent
      }));
 
      const filteredEquipes = equipes.filter(equipe => equipe.idepr === idEpr);

      // Récupérer les deux dernières équipes
      let returnList =  filteredEquipes;

      if (twoLast){
        returnList = filteredEquipes.slice(-2);
      }

      return returnList;
    } catch (error) {
      console.error('Error fetching equipes:', error);
      return [];
    }
  }

  async fetchMatchs(liendivision) {
    const password = this.ffttPass;
    const serie = generateSerieNumber();
    const tm = generateTimestamp();
    const tmc = encryptTimestamp(tm, password);

    try {
      const response = await axios.get('https://www.fftt.com/mobile/pxml/xml_result_equ.php', {
        params: {
          serie: serie,
          tm: tm,
          tmc: tmc,
          id: this.ffttId,
          action: '',
          ...liendivision
        }
      });
      const xmlDoc = parseXML(response.data);
      return Array.from(xmlDoc.getElementsByTagName("tour")).map(match => ({
        libelle: match.getElementsByTagName("libelle")[0].textContent,
        equa: match.getElementsByTagName("equa")[0].textContent,
        equb: match.getElementsByTagName("equb")[0].textContent,
        scorea: match.getElementsByTagName("scorea")[0].textContent,
        scoreb: match.getElementsByTagName("scoreb")[0].textContent,
        dateprevue:  match.getElementsByTagName("dateprevue")[0].textContent,
        datereelle: match.getElementsByTagName("datereelle")[0].textContent

        
      }));
    } catch (error) {
      console.error('Error fetching matchs:', error);
      return [];
    }
  }

  async fetchJoueursByPoints(topThree = false) {
    const password = this.ffttPass;
    const serie = generateSerieNumber();
    const tm = generateTimestamp();
    const tmc = encryptTimestamp(tm, password);

    try {
        const licenceResponse = await axios.get('https://www.fftt.com/mobile/pxml/xml_liste_joueur_o.php', {
            params: {
                serie: serie,
                tm: tm,
                tmc: tmc,
                id: this.ffttId,
                club: this.ffttNumClub
            }
        });

        const xmlLicenceDoc = parseXML(licenceResponse.data);
        const joueursElements = xmlLicenceDoc.getElementsByTagName("joueur");
        const joueurs = [];

        // Pour chaque joueur, extraire les détails nécessaires
        for (let i = 0; i < joueursElements.length; i++) {
            const nom = joueursElements[i].getElementsByTagName("nom")[0].textContent;
            const prenom = joueursElements[i].getElementsByTagName("prenom")[0].textContent;
            const pointsText = joueursElements[i].getElementsByTagName("points")[0]?.textContent || '0';
            const points = parseInt(pointsText, 10); // Convertir explicitement en entier

            joueurs.push({
                nom: nom,
                prenom: prenom,
                points: points
            });
            
        }

        // Trier les joueurs par points
        joueurs.sort((a, b) => b.points - a.points);

        // Retourner uniquement les trois premiers joueurs si topThree est vrai
        if (topThree) {
            return joueurs.slice(0, 3);
        }

        return joueurs;
    } catch (error) {
        console.error('Error fetching joueurs by points:', error);
        return [];
    }
  }

}
